<app-button variant="outlined" severity="contrast" [icon]="SVG.SHARE" [iconSource]="'svg'" [size]="'default'"
    label="Share" (clicked)="openShareDialog()" />

@if(shareDialog) {
<p-dialog [visible]="shareDialog" [appendTo]="'body'" [modal]="true" [closeOnEscape]="true" [closable]="false"
    [style]="{'width':'45rem' ,'height' : '50rem'}" (onHide)="onCloseShareDialog()" [position]="'center'"
    [draggable]="false">
    <ng-template pTemplate="header">
        <div class="w-full flex justify-between">
            <div class="font-bold text-md truncate mr-4">Share this report</div>
            <div class="flex items-center">
                <app-icon [type]="'pi pi-times'" [source]="'primeng'" [size]="'default'"
                    (click)="toggleShareDialog()"></app-icon>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <app-share-to-users [analysisReport]="analysisReport._id" [shareDetails]="shareDetails" [projectId]="projectId"
            [workspace]="workspaceAsObject" (addUserToShare)="addUserToShare($event)"
            (removeUserFromShare)="removeUserFromShare($event)" (updateSharedUser)="updateSharedUser($event)"
            (changeSharedWithWorkspace)="changeSharedWithWorkspace($event)"
            (changeSharedWithProject)="changeSharedWithProject($event)"
            (changeAnyoneAccess)="changeAnyoneAccess($event)"
            (refreshShareDetails)="refreshShareDetails()"></app-share-to-users>
    </ng-template>
</p-dialog>
}